<template>
  <div class="order_list_box" :style="'min-height:' + height + 'px;'">
    <p class="box_title">{{ $t('center.Hotel_order') }}</p>
    <div class="box_form">
      <div>
        <p style="color: #676767;margin-bottom: 5px;">{{ $t('center.Order_status') }} :</p>
        <el-select v-model="orderForm.orderStatus" placeholder="请选择" style="width: 100px;" size="mini">
          <el-option v-for="item in orderStatusOptions" :key="item.id" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">{{ $t('cashier.order_num') }} :</p>
        <el-input style="width: 180px" v-model="orderForm.orderNum" :placeholder="$t('center.fill_in_order_num')" size="mini"
                  clearable></el-input>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">入住人:</p>
        <el-input style="width: 120px" v-model="orderForm.guestName" placeholder="入住人" size="mini"
                  clearable></el-input>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">酒店名称:</p>
        <el-input style="width: 180px" v-model="orderForm.hotelName" placeholder="酒店名称" size="mini"
                  clearable></el-input>
      </div>
      <div class="time_box">
        <div>
          <p style="color: #676767;margin-bottom: 5px;">{{ $t('center.Date_selection') }} :</p>
          <el-select v-model="orderForm.timeType" placeholder="请选择" style="width: 110px;" size="mini">
            <el-option :label="$t('center.Reservation_date')" :value="1"> </el-option>
            <el-option :label="$t('center.Date_of_check_in')" :value="2"> </el-option>
          </el-select>
        </div>

        <div>
          <p style="color: #676767;margin-bottom: 12px;"></p>
          <el-date-picker v-model="orderForm.dateRange" type="daterange" range-separator="-"
            :start-placeholder="$t('center.Start_date')" :end-placeholder="$t('center.End_date')"
            value-format="yyyy-MM-dd" size="mini" style="position: relative;top: 2px;width: 230px !important;">
          </el-date-picker>
        </div>
        <div>
          <p style="color: #676767;margin-bottom: 15px;"></p>
          <b2b-button style="width: 60px;height: 28px;line-height: 28px;" @click="search">{{
            $t('search.searchBtn')
          }}</b2b-button>
          <b2b-button style="width: 80px;height: 28px;line-height: 28px;font-size: 12px;margin-left: 8px"
                      @click="showPurchaseDialog" v-if="showBtn">新增外采订单</b2b-button>
        </div>
      </div>
    </div>
    <div class="order_data">
      <el-table :data="orders" style="width: 100%; margin-top: 20px; font-size: 12px" :empty-text="$t('center.no_data')">
        <el-table-column :label="$t('center.orders')" width="205">
          <template slot-scope="scope">
            <div>{{ $t('center.Cozytime_order') }}：{{ scope.row.outerOrderId }}</div>
            <div>{{ $t('center.your_order') }}：{{ scope.row.channelOrderNum }}</div>
            <div>{{ $t('center.confirmation_number') }}：{{
              scope.row.hotelConfirmationNumber ?
              scope.row.hotelConfirmationNumber : '/'
            }}
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('center.hotel_room_name')" width="220">
          <template slot-scope="scope">
            <div style="color: #144199">
              {{ scope.row.hotelName }}
            </div>
            <div>房型：{{ scope.row.roomTypeName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="orderTime" :label="$t('center.Order_time')" width="150">
        </el-table-column>
        <el-table-column prop="orderClassification" label="类型" width="70" v-if="showBtn">
          <template slot-scope="scope">
            {{ orderClassificationDesc(scope.row.orderClassification)  }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('center.Order_status')" width="100">
          <template slot-scope="scope" style="text-align: center">
            <div class="order-status-span" :style="'background-color:' + getStatusColor(scope.row.orderStatus)">
              {{ scope.row.orderStatusName }}
            </div>
            <br />
            <div class="order-status-span">
              {{ scope.row.orderStatusChannel ? channelStatus[scope.row.orderStatusChannel] : $t('center.To_be_paid') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('center.Order_amount')" width="90">
          <template slot-scope="scope">
            {{ $commonUtil.formatPrice(scope.row.payAmount) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('center.check_in_out')" width="110">
          <template slot-scope="scope">
            <div>{{ scope.row.checkIn }}</div>
            <div>{{ scope.row.checkOut }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('search.rooms_and_guests').replace(',', '/')" width="120">
          <template slot-scope="scope">
            <div>
              {{ $t('booking.guest') }}：{{ $commonUtil.formatGuestName(scope.row.guestName) }}
            </div>
            <div>{{ $t('search.room') }}：{{ scope.row.roomCount }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('center.operation')" min-width="110">
          <template slot-scope="scope">
            <p @click="showDetail(scope.row)" style="color:#1e50f0;cursor: pointer;">{{ $t('center.detail') }}</p>
            <p @click="showAddWorkOrder(scope.row)" style="color:#1e50f0;cursor: pointer;"
              v-if="!(scope.row.orderStatusName == '已创建' || scope.row.orderStatusName == '订单关闭')">提交工单</p>
            <p @click="payOrder(scope.row)" style="color:#1e50f0;cursor: pointer;"
               v-if="(!scope.row.orderStatusChannel || scope.row.orderStatusChannel === 0 || channelStatus[scope.row.orderStatusChannel] === '未付款') &&
                (!scope.row.orderStatus || scope.row.orderStatus === 0) && isInPayTime(scope.row.orderTime)">
              去支付
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination :current-page="orderForm.current" :page-size="orderForm.size"
        layout="total, prev, pager, next, jumper" :total="orderForm.total" :hide-on-single-page="true"
        @current-change="pageChange" style="margin: auto;">
      </el-pagination>
    </div>
    <el-dialog title="提交工单" :visible.sync="showAddWorkOrderDialog" width="750px" :lock-scroll="false">
      <AddWorkOrder :orderInfo="orderInfo" :showAddWorkOrderDialog="showAddWorkOrderDialog" @closeDialog="closeDialog"
        @toDetail="showDetail" type="orderList" />
    </el-dialog>
    <PurchaseDialog ref="purchaseDialog" @createSuccess="search"/>
  </div>
</template>

<script>
import AddWorkOrder from './components/AddWorkOrder.vue'
import PurchaseDialog from './components/PurchaseDialog.vue'
export default {
  data () {
    return {
      height: 0,
      orderForm: {
        channelIds: [],
        orderStatus: -1,
        total: 0,
        size: 10,
        current: 1,
        timeType: 1,
        orderStatusList: null,
        checkIn: "",
        checkOut: "",
        dateRange: [],
        orderNum: ""
      },
      orderStatusOptions: [
        { id: 0, name: this.$t('center.all'), value: -1 },
        { id: 1, name: this.$t('center.Processing'), value: [0, 1, 4, 5, 11] },
        { id: 2, name: this.$t('center.Confirmed'), value: [2, 13, 14] },
        { id: 3, name: this.$t('center.Canceled'), value: [3, 15] },
        { id: 4, name: this.$t('center.Full_house'), value: [12] },
        { id: 5, name: this.$t('center.Order_Close'), value: [16] },
        { id: 6, name: '已入住', value: [7] }
      ],
      channelStatus: {
        0: this.$t('center.Unpaid'),
        1: this.$t('center.Paid'),
        2: this.$t('center.Paid'),
        3: this.$t('center.Canceled'),
        4: this.$t('center.Refunded')
      },
      orders: [],
      showAddWorkOrderDialog: false,
      orderInfo: {},
      showBtnDialogPartners: [1000]
    }
  },
  components: {
    PurchaseDialog,
    AddWorkOrder
  },
  computed: {
    showBtn () {
      let partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'))
      return this.showBtnDialogPartners.includes(partnerInfo.partnerCode)
    }
  },
  created () {
    let partnerInfo = JSON.parse(this.$common.isLogin())
    if (!partnerInfo) {
      this.$message.warning('请登录后再查看')
      this.$router.push('/login')
    } else {
      this.height = this.$common.getScreenInfo().height - 90 - 40
      if (partnerInfo.homeChannelId) {
        this.orderForm.channelIds.push(partnerInfo.homeChannelId)
      }
      if (partnerInfo.overseaChannelId) {
        this.orderForm.channelIds.push(partnerInfo.overseaChannelId)
      }
      let params = this.$route.query
      if (params && params.clientReference) {
        this.searchOneOrderToDetail(params.clientReference)
      }
      this.search()
    }
  },
  methods: {
    async searchOneOrderToDetail(channelOrderNum) {
      let headers = { accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : '' }
      let reqForm = {...this.orderForm}
      reqForm.current = 1
      reqForm.orderNum = channelOrderNum
      const {data: result} = await this.$http.post('/b2b/searchB2BOrder', reqForm, {headers})
      if (result.code !== 200) return
      if (result.data && result.data.orderList.length) {
        await this.$router.replace({
          path: '/orderDetail',
          query: {
            params: window.btoa(encodeURIComponent(JSON.stringify(result.data.orderList[0])))
          }
        })
      }
    },
    search (type) {
      if (type != 1) {
        this.orderForm.current = 1
      }
      if (this.orderForm.orderStatus != -1) {
        this.orderForm['orderStatusList'] = this.orderForm.orderStatus
      } else {
        this.orderForm['orderStatusList'] = null
      }
      if (this.orderForm.dateRange) {
        this.orderForm['checkIn'] = this.orderForm.dateRange[0]
        this.orderForm['checkOut'] = this.orderForm.dateRange[1]
      } else {
        this.orderForm['checkIn'] = null
        this.orderForm['checkOut'] = null
      }

      let vm = this
      let loading = vm.$loading({
        text: '努力加载中，请稍后.....',
        spinner: 'el-icon-loading',
        background: vm.$finalData.LoadingBgColorAll
      })
      let headers = { accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : '' }
      vm.$http.post('/b2b/searchB2BOrder', vm.orderForm, {headers}).then(resp => {
        let result = resp.body
        if (result.success) {
          vm.orders = result.data.orderList
          vm.orders.forEach(item => {
            this.$set(item, "orderStatusName", this.getStatusName(item.orderStatus))
            if (item.isManualOrder === 1 && item.orderClassification === 1) {
              this.$delete(item, 'hotelId')
              let ex = JSON.parse(item.extensions)
              this.$set(item, 'hotelName', ex.hotelName)
              this.$set(item, 'roomTypeName', ex.roomName)
            }
          })
          vm.orderForm.total = result.data.total
        } else {
          vm.$message.error('错误：' + result.message)
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
        loading.close()
      })
    },
    getStatusColor (val) {
      if (!val) {
        return '#ffffff'
      }
      for (let i = 1; i < this.orderStatusOptions.length; i++) {
        let item = this.orderStatusOptions[i]
        if (item.value.indexOf(val) != -1) {
          return item.color
        }
      }
      return '#ffffff'
    },
    getStatusName (val) {
      if (!val) {
        return this.$t('center.Created')
      }
      for (let i = 1; i < this.orderStatusOptions.length; i++) {
        let item = this.orderStatusOptions[i]
        if (item.value.indexOf(val) != -1) {
          return item.name
        }
      }
      return ''
    },
    pageChange (e) {
      this.orderForm.current = e
      this.search(1)
    },
    showDetail (row) {
      let url = '/orderDetail?params=' + window.btoa(encodeURIComponent(JSON.stringify(row)))
      window.open(url, '_blank');
    },
    async showAddWorkOrder (row) {
      this.orderInfo = row
      this.showAddWorkOrderDialog = true
    },
    payOrder (row) {
      this.$router.push({
        path: '/cashier',
        query: {
          outerId: row.outerOrderId,
          orderTime: row.orderTime
        }
      })
    },
    isInPayTime (orderTime) {
      let time = new Date(orderTime).getTime()
      let curr = Date.now();
      return curr - time < 900000
    },
    closeDialog () {
      this.showAddWorkOrderDialog = false
    },
    showPurchaseDialog () {
      this.$refs['purchaseDialog'].init()
    },
    orderClassificationDesc (orderClassification) {
      if (!orderClassification || orderClassification === 0) return '分销单'
      if (orderClassification === 1) return '外采单'
      if (orderClassification === 2) return '托管单'
    }
  }
}
</script>

<style lang="less" scoped>
.order_list_box {
  background-color: #fff;
  padding: 20px;

  .box_title {
    font-size: 16px;
    font-weight: bold;
    font-family: '苹方';
    margin-bottom: 15px;
  }


  .box_form {
    padding: 20px;
    border: 1px solid #e7e7e7;
    background-color: #f7f7f7;
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 15px;
    row-gap: 15px;
    align-items: center;

    .time_box {
      display: grid;
      grid-template-columns: repeat(3, max-content);
      align-items: center;
      grid-column-gap: 10px;
    }

    & /deep/ .el-input .el-select {
      min-width: auto !important;
      width: auto !important;
    }
  }

  .pagination {
    margin: 35px;
    position: relative;

    /deep/ .el-pagination {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  /deep/.el-table th,
  .el-table tr {
    background-color: #f7f7f7;
  }

  /deep/.el-button--primary:hover {
    background-color: #1e50f0;
    opacity: .8;
  }

  /deep/ .el-dialog__header {
    background-color: #fff;
    padding: 10px 20px;
  }

  /deep/ .el-dialog__title {
    color: #000;
    font-size: 16px;
    font-weight: 500;
  }

  /deep/ .el-dialog__body {
    padding: 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/OrderList.vue